module.exports = __webpack_public_path__ + "fonts/NanumSquareOTFB.71fd93e0.eot";